import { ChakraHStack as HStack, ChakraText as Text, ChakraFlex as Flex } from "@airhelp/react-ui-components";
import { Stars } from "modules/common/components/Trustpilot/ReviewCard/Stars";
import type { CardHeaderProps } from "./CardHeader.d";

export const CardHeader = ({ rating, date }: CardHeaderProps) => {
  const starsAmount = Number(rating);
  return (
    <Flex align="center" justify="space-between">
      {starsAmount > 0 && (
        <HStack spacing={1} mb={12}>
          <Stars amount={starsAmount} />
        </HStack>
      )}
      {date && <Text color="greyscale.500">{date}</Text>}
    </Flex>
  );
};
